module.exports = __webpack_public_path__ + "static/media/sync-alt.2dc76a63.svg";